import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import "assets/scss/material-kit-react.scss?v=1.4.0";
import 'typeface-roboto';
import 'typeface-roboto-slab';
// @material-ui/icons

// React icons

// core components
import Footer from "components/Footer/FooterDomApotheke.jsx";
import Muted from "components/Typography/Muted.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

//Images
import HeaderSection from "./Sections/HeaderSection";

class SchreinersApotheken extends React.Component {
    render() {
        const {classes} = this.props;
        return (
            <div>
                <HeaderSection />
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.section}>
                        <div className={classes.container}>
                            <Muted>
                                <br/><br/>
                                <h1>Impressum</h1>
                                <br/>
                                <p><strong>Impressum der Dom-Apotheke</strong></p>
                                <p>&nbsp;</p>
                                <p><strong>Firmenname:</strong></p>
                                <p>Dom-Apotheke, Christian Schreiner e.K.</p>
                                <p><strong>Anschrift:</strong></p>
                                <p>Russellplatz 2, 45894 Gelsenkirchen</p>
                                <p><strong>Inhaber:</strong></p>
                                <p>Herr Christian Schreiner</p>
                                <p><strong>Filialleitung:</strong></p>
                                <p>Frau Dana Schreiner</p>
                                <p><strong>Telefon:</strong></p>
                                <p>0209/359 80 70 1</p>
                                <p><strong>Fax:</strong></p>
                                <p>0209/359 80 70 2</p>
                                <p><strong>E-Mail:</strong></p>
                                <p><a href="mailto:email@dom-apotheke-buer.de">email@dom-apotheke-buer.de</a></p>
                                <p>&nbsp;</p>
                                <p>Angaben gem&auml;&szlig; &sect; 5 des Telemediengesetzes</p>
                                <p><strong>Zust&auml;ndige Apothekerkammer:</strong></p>
                                <p>Apothekerkammer Westfalen-Lippe</p>
                                <p><strong>Anschrift:</strong></p>
                                <p>Bismarckallee 25, 48151 M&uuml;nster</p>
                                <p><strong>Telefon:</strong></p>
                                <p>0251-520050</p>
                                <p><strong>Fax:</strong></p>
                                <p>0251-521650</p>
                                <p><strong>Web:</strong></p>
                                <p><a href="http://www.akwl.de/"><strong>http://www.akwl.de</strong></a></p>
                                <p><strong>E-Mail:</strong></p>
                                <p><a href="mailto:info@akwl.de"><strong>info@akwl.de</strong></a></p>
                                <p>Es gilt die&nbsp;<a href="http://www.akwl.de/inhalt.php?id=104"><strong>Berufsordnung</strong></a>&nbsp;f&uuml;r Apothekerinnen und Apotheker der oben genannten Apothekerkammer.</p>
                                <p>Weitere berufsrechtliche Regelungen:&nbsp;<a href="http://www.gesetze-im-internet.de/apog/"><strong>Apothekengesetz</strong></a>,&nbsp;<a href="http://www.gesetze-im-internet.de/apobetro_1987/"><strong>Apothekenbetriebsordnung</strong></a>,&nbsp;<a href="http://www.gesetze-im-internet.de/bapo/"><strong>Bundes-Apothekerordnung</strong></a>.</p>
                                <p>Die gesetzliche Berufsbezeichnung Apotheker wurde in Deutschland erworben.</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p><strong>Aufsichtsbeh&ouml;rde:</strong></p>
                                <p>Stadt Gelsenkirchen, Referat Gesundheit -53, Kurt-Schumacher-Str. 4, 45879 Gelsenkirchen</p>
                                <p><strong>Handelsregister:</strong></p>
                                <p>Amtsgericht Gelsenkirchen</p>
                                <p><strong>Handelsregister-Nr.:</strong></p>
                                <p>HRA 1941</p>
                                <p><strong>USt. Ident-Nr:</strong></p>
                                <p>DE 230429417</p>
                                <p>Haftung f&uuml;r Inhalte</p>
                                <p>Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen, die auf eine rechtswidrige T&auml;tigkeit hinweisen.</p>
                                <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
                                <p>Haftung f&uuml;r Links</p>
                                <p>Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
                                <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
                                <p>Urheberrecht</p>
                                <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.</p>
                                <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
                                <p>Quelle:&nbsp;<a href="https://www.e-recht24.de/">e-recht24.de</a></p>
                                <p>Dieses Impressum ist auch f&uuml;r die Facebookseite https://www.facebook.com/domapothekebuer&nbsp;g&uuml;ltig.</p>
                                <br/>
                                <br/>
                            </Muted>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default withStyles(landingPageStyle)(SchreinersApotheken);
